<template>
    <div class="card">
        <header class="card__header clearfix" v-if="heading">
            <div class="row">
                <div class="columns shrink no-pad">
                    <h3 class="card__heading no-margin" v-if="heading">{{ heading }}</h3>
                </div>
                <div class="columns align-right no-pad">
                    <slot name="card-actions"></slot>
                </div>
            </div>
        </header>
        <slot name="custom-heading"></slot>
        <div
            class="card__content"
            :class="cardContentClasses">
            <loading-spinner
                :message="loadingMessage"
                transition="fade"
                transition-mode="out-in"
                v-if="loading">
            </loading-spinner>
            <slot></slot>
        </div>
        <slot name="card-footer"></slot>
    </div>
</template>

<script>
    import LoadingSpinner from './LoadingSpinner'

    /**
     * Card Component
     */
    export default {
        name: 'card',
        components: {
            LoadingSpinner
        },
        props: {
            heading: {
                type: String,
                required: false
            },
            loading: {
                type: Boolean,
                required: false
            },
            flat: {
                type: Boolean,
                required: false,
                default: false
            },
            loadingMessage: {
                type: String,
                required: false,
                default: ''
            }
        },
        computed: {
            cardContentClasses () {
                return {
                    'no-pad': this.flat
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "../../styles/_variables.scss";

    .card {
        position: relative;
        background-color: #FFF;
        margin-bottom: $global-padding;
        border-radius: 3px;
        border: 1px solid $border-color;

        &--big-shadow { box-shadow: 0 2px 20px rgba(0, 0, 0, 0.65); }

        &__header {
            padding: ($global-padding / 2) $global-padding;
            border-bottom: 1px solid $border-color;
        }

        &__heading {
            color:  $light-blue;
            font-size: 18px;
            margin: 0;
            font-weight: bold;
            float: left;

            span {
                font-weight: 400;
                font-size: 14px;
                margin-left: 5px;
            }
        }

        &__content { padding: $global-padding ($global-padding / 2); }

        &__sub-title {
            margin: 0 0 ($global-padding / 2) 0;
            font-style: italic;
            font-weight: bold;
            color: #808080;
            font-size: 0.85em;
            font-weight: bold;
            font-style: normal;
        }

        &__value {
            border-radius: 3px;
            border: 1px solid $border-color;
            padding: $global-padding / 2;

            &-heading {
                display: block;
                font-weight: bold;
                font-size: .7em;
                font-style: italic;
            }

            &-result {
                font-size: 1.2em;
                font-weight: bold;
            }
        }

        &__footer {
            padding: $global-padding;
            background: #f9f9f9;
            border-top: 1px solid $border-color;

            .button {
                vertical-align: top;
                font-size: 13px;
            }

            .button--success { margin-left: 15px; }
        }

        &--large {
            margin: 0 auto;
            max-width: 800px;
        }

        &--small {
            margin: 0 auto;
            max-width: 500px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/general/Card.vue